<template>
    <span v-if="mostrarBtnAtualizarDataPrevisao" class="ml-2">
        <b-button
            variant="primary"
            @click.stop="abrirEntregaAtualizarDataPrevisao()"
        >
            <span>
                <i class="fa fa-calendar"></i> Reprogramar Data de Previsão
            </span>
        </b-button>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Entrega - Reprogramar Data de Previsão</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Data previsão atual</label>
                        <b-form-input
                            type="text"
                            v-model="dataPrevisaoAtual"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.dataPrevisaoAtualizada.$error ? false : null"
                        invalid-feedback="Data de previsão atualizada é obrigatória"
                    >
                        <label>Data de Previsão Reprogramada</label>
                        <date-picker
                            v-model="dataPrevisaoAtualizada"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataPrevisaoAtualizada.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharEntregaAtualizarDataPrevisao()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAtualizarDataPrevisao()"
                    >Reprogramar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            dataPrevisaoAtual: '',
            dataPrevisaoAtualizada: '',
            justificativa: ''
        }
    },

    methods: {
        abrirEntregaAtualizarDataPrevisao() {
            this.mostrarModal = true
            this.dataPrevisaoAtual = this.$moment(
                this.entrega.dataPrevisao
            ).format('DD/MM/YYYY')
        },

        fecharEntregaAtualizarDataPrevisao() {
            this.mostrarModal = false
            this.resetEntregaAtualizarDataPrevisao()
        },

        resetEntregaAtualizarDataPrevisao() {
            this.dataPrevisaoAtual = ''
            this.dataPrevisaoAtualizada = ''
            this.justificativa = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarAtualizarDataPrevisao() {
            this.$swal({
                title: 'Reprogramar Data de Previsão',
                html: `Confirma a reprogramação da data de previsão da entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarDataPrevisao()
                }
            })
        },

        atualizarDataPrevisao() {
            this.$store.dispatch('addRequest')
            let dataPrevisaoAtualizadaDto = {
                entregaId: this.entrega.entregaId,
                dataPrevisaoAtualizada: this.$moment(
                    this.dataPrevisaoAtualizada,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                justificativa: this.justificativa
            }
            this.entregasServicos
                .atualizarDataPrevisao(dataPrevisaoAtualizadaDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                            this.fecharEntregaAtualizarDataPrevisao()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAtualizarDataPrevisao() {
            let retorno =
                (this.$temAcesso('CRED-UABS-ENTR-04') ||
                    this.$temAcesso('CRED-GEST-ENTR-05')) &&
                (this.entrega.status == entregaStatus.EM_ABERTO ||
                    this.entrega.status == entregaStatus.REPROVADA)
            return retorno
        }
    },

    validations: {
        dataPrevisaoAtualizada: {
            required
        },
        justificativa: {
            required
        }
    }
}
</script>
